const team = {
  header: {
    title: "Команда и доступ к рабочим пространствам",
    description: "У каждого участника изолированное пространство для обработки и публикации контента: собственные Источники, Фильтры, настройки ИИ, отслеживаемые публикации, Content Inbox, состояние проверки, история публикаций, токен Telegram-бота и назначения. Управление командой и системные настройки доступны только Super-Admin.",
    currentAdministrator: "Текущий системный администратор",
    superAdminFallback: "Super-Admin",
  },
  isolation: {
    inboxTitle: "Личный Content Inbox",
    inboxDescription: "Редактирование, одобрение, архивирование, результаты публикации и история принадлежат только этому участнику.",
    destinationsTitle: "Личные назначения",
    destinationsDescription: "У каждого участника отдельный токен Telegram-бота и собственный список назначений.",
    setupTitle: "Личные настройки обработки",
    setupDescription: "Каждый участник управляет собственными источниками, фильтрами, настройками ИИ и отслеживаемыми публикациями.",
  },
  form: {
    title: "Добавить участника",
    description: "Новые аккаунты используют Supabase Auth и получают отдельное личное рабочее пространство.",
    email: "Email",
    emailPlaceholder: "member@example.com",
    emailHelp: "Email становится постоянной идентичностью Supabase для изоляции личных данных.",
    password: "Временный пароль",
    passwordPlaceholder: "Минимум 8 символов",
    role: "Роль доступа",
    roles: {
      adminOption: "Admin — Личная обработка и публикация",
      superAdminOption: "Super-Admin — Личное пространство + системное администрирование",
      adminTitle: "Доступ Admin",
      superAdminTitle: "Доступ Super-Admin",
      adminDescription: "Получает личные источники, фильтры, настройки ИИ, отслеживаемые публикации, Inbox, назначения и историю публикаций.",
      superAdminDescription: "Получает полностью личное рабочее пространство плюс право управлять командой и состоянием системы.",
    },
    submit: "Создать участника",
    submitting: "Создание участника…",
  },
  feedback: {
    validEmail: "Введите корректный email. Новые участники используют Supabase Auth.",
    passwordLength: "Временный пароль должен содержать не менее 8 символов.",
    provisionSuccess: "Участник “{{identity}}” создан с полностью изолированным пространством обработки и публикации.",
    provisionFailed: "Не удалось создать этого участника.",
    revokeConfirm: "Отозвать доступ у “{{identity}}”? Источники, фильтры, настройки ИИ, отслеживаемые публикации, Inbox, назначения и история публикаций сохранятся для аудита/восстановления, но вход будет запрещён.",
    revokeSuccess: "Доступ для “{{identity}}” отозван. Данные личного пространства сохранены.",
    revokeFailed: "Не удалось отозвать доступ. Убедитесь, что вы не отключаете себя или последнего Super-Admin.",
    revokeAccountFailed: "Не удалось отозвать доступ к этому аккаунту.",
  },
  members: {
    title: "Участники рабочего пространства",
    summary: "{{active}} активных · {{total}} всего",
    legacySuffix: " · {{legacy}} legacy",
    isolationEnabled: "Изоляция личных пространств включена",
    legacyTitle: "Legacy-аккаунты всё ещё существуют",
    legacyDescription: "Они остаются совместимыми и используют нормализованное имя пользователя как ключ личного пространства. Новых участников лучше создавать через email, чтобы владение было связано с неизменяемым ID пользователя Supabase.",
    you: "Вы",
    roles: {
      superAdmin: "Super-Admin",
      admin: "Admin",
    },
    status: {
      active: "Активен",
      revoked: "Доступ отозван",
    },
    added: "Добавлен {{date}}",
    providers: {
      supabase: "Supabase Auth",
      legacy: "Legacy-идентичность",
    },
    privateWorkspace: "Личный Inbox + назначения",
    legacyWarning: "Владение legacy-пространством основано на имени пользователя. Для новых участников используйте email/Supabase.",
    revoke: "Отозвать доступ",
    emptyTitle: "Участники не найдены",
    emptyDescription: "Создайте первый аккаунт через форму.",
  },
} as const;

export default team;
